// Bilingual label dictionaries (NFR6). Keys are stable; values localized.
export type Locale = "th" | "en";

export const MESSAGES = {
  th: {
    appName: "แผนเกษียณ",
    signIn: "เข้าสู่ระบบ",
    signOut: "ออกจากระบบ",
    dashboard: "แดชบอร์ด",
    assumptions: "สมมติฐาน",
    projection: "จะเกษียณได้เมื่อไหร่?",
    montecarlo: "จำลองมอนติคาร์โล",
    accounts: "บัญชี (กรอกเอง)",
    netWorth: "มูลค่าสุทธิ",
    addAccount: "เพิ่มบัญชี",
    onTrack: "ตามแผน",
    caution: "ระวัง",
    behind: "ต่ำกว่าแผน",
    save: "บันทึกและคำนวณใหม่",
    preview: "ประมาณการ",
    confirmed: "ยืนยันแล้ว",
    syncing: "กำลังซิงค์…",
    currentAge: "อายุปัจจุบัน",
    targetRetirementAge: "อายุที่ต้องการเกษียณ",
    currentSavings: "เงินออมปัจจุบัน",
    monthlyContribution: "เงินสะสมต่อเดือน",
    targetAnnualSpending: "ค่าใช้จ่ายต่อปีหลังเกษียณ",
    expectedReturn: "ผลตอบแทนคาดหวัง",
    inflation: "เงินเฟ้อ",
    swr: "อัตราถอนปลอดภัย",
    planToAge: "วางแผนถึงอายุ",
    probabilityLast: "โอกาสที่เงินจะพอถึงอายุ",
    viewDataTable: "ดูตารางข้อมูล",
    textSummary: "สรุปเป็นข้อความ",
    skipToMain: "ข้ามไปยังเนื้อหาหลัก",
    loading: "กำลังโหลด…",
    retry: "ลองใหม่",
    somethingWrong: "เกิดข้อผิดพลาด",
    real: "มูลค่าจริง (ปรับเงินเฟ้อ)",
  },
  en: {
    appName: "Retirement Planner",
    signIn: "Sign in",
    signOut: "Sign out",
    dashboard: "Dashboard",
    assumptions: "Assumptions",
    projection: "When can I retire?",
    montecarlo: "Monte Carlo",
    accounts: "Accounts (manual)",
    netWorth: "Net worth",
    addAccount: "Add account",
    onTrack: "ON TRACK",
    caution: "CAUTION",
    behind: "BEHIND",
    save: "Save & recalculate",
    preview: "Preview",
    confirmed: "Confirmed",
    syncing: "syncing…",
    currentAge: "Current age",
    targetRetirementAge: "Target retirement age",
    currentSavings: "Current savings",
    monthlyContribution: "Monthly contribution",
    targetAnnualSpending: "Target annual spending in retirement",
    expectedReturn: "Expected nominal return",
    inflation: "Inflation",
    swr: "Safe withdrawal rate",
    planToAge: "Plan to age",
    probabilityLast: "Probability your funds last to age",
    viewDataTable: "View data table",
    textSummary: "Text summary",
    skipToMain: "Skip to main content",
    loading: "Loading…",
    retry: "Retry",
    somethingWrong: "Something went wrong",
    real: "real (inflation-adjusted)",
  },
} as const;

export type MessageKey = keyof (typeof MESSAGES)["en"];
